import http from 'plugins/axios';

export default {
    getBeforeDayData(data) {
        return http.get({
            url: '/admin/etp/preview/beforeDay',
            data
        });
    },

    getHoldInfo(data) {
        return http.get({
            url: '/admin/etp/preview/holdInfo',
            data
        });
    },

    getHoldTop(data) {
        return http.get({
            url: '/admin/etp/preview/holdTop',
            data
        });
    },

    getStatistics(data) {
        return http.get({
            url: '/admin/etp/preview/statistics',
            data
        });
    },
};
